<template>
  <div
    class="flex flex-wrap justify-center gap-2 small-icons-grid md:justify-start"
    v-if="methods && methods.length > 0"
  >
    <div v-for="(method, idx) in methods" :key="idx" class="w-12">
      <VisaIcon v-if="method === 'visa'" />
      <MastercardIcon v-if="method === 'masterCard'" />
      <AmericanExpressIcon v-if="method === 'americanExpress'" />
      <KlarnaIcon v-if="method === 'klarna'" />
      <PayPalIcon v-if="method === 'paypal'" />
      <img
        v-if="method === 'googlePay'"
        src="@/assets/images/icons/payment/google-pay.svg"
        :alt="$t('paymentmethods.google-pay')"
        loading="lazy"
      />
      <img v-if="method === 'twint'" src="@/assets/images/icons/payment/twint.png" :alt="$t('paymentmethods.twint')" />
      <img
        v-if="method === 'postfinance'"
        src="@/assets/images/icons/payment/postfinance.png"
        :alt="$t('paymentmethods.postfinance')"
        loading="lazy"
      />
      <img
        v-if="method === 'applePay'"
        src="@/assets/images/icons/payment/apple-pay.svg"
        :alt="$t('paymentmethods.apple-pay')"
        loading="lazy"
      />
      <img
        v-if="method === 'amazonPay'"
        src="@/assets/images/icons/payment/amazon-pay.svg"
        :alt="$t('paymentmethods.amazon-pay')"
        loading="lazy"
      />
      <img
        v-if="method === 'sepaLastschrift'"
        src="@/assets/images/icons/payment/sepa-lastschrift.svg"
        :alt="$t('paymentmethods.sepa-lastschrift')"
        loading="lazy"
      />
      <img
        v-if="method === 'vorkasse'"
        src="@/assets/images/icons/payment/vorkasse.svg"
        :alt="$t('paymentmethods.prepayment')"
        loading="lazy"
      />
      <img v-if="method === 'mollie'" src="@/assets/images/icons/payment/ideal.svg" :alt="$t('paymentmethods.ideal')" />
      <img
        v-if="method === 'bancontact'"
        src="@/assets/images/icons/payment/bancontact.svg"
        :alt="$t('paymentmethods.bancontact')"
        loading="lazy"
      />
      <img
        v-if="method === 'belfius'"
        src="@/assets/images/icons/payment/belfius.svg"
        :alt="$t('paymentmethods.belfius')"
        loading="lazy"
      />
      <img
        v-if="method === 'sofort'"
        src="@/assets/images/icons/payment/sofortuberweisung.png"
        srcset="
          @/assets/images/icons/payment/sofortuberweisung.png,
          @/assets/images/icons/payment/sofortuberweisung@2x.png 2x,
          @/assets/images/icons/payment/sofortuberweisung@3x.png 3x
        "
        :alt="$t('paymentmethods.sofortueberweisung')"
        loading="lazy"
      />
      <img
        v-if="method === 'paydirect'"
        src="@/assets/images/icons/payment/paydireckt.png"
        srcset="
          @/assets/images/icons/payment/paydireckt.png,
          @/assets/images/icons/payment/paydireckt@2x.png 2x,
          @/assets/images/icons/payment/paydireckt@3x.png 3x
        "
        :alt="$t('paymentmethods.paydirect')"
        loading="lazy"
      />
      <img
        v-if="method === 'payconiq'"
        src="@/assets/images/icons/payment/payconiq.png"
        srcset="
          @/assets/images/icons/payment/payconiq.png,
          @/assets/images/icons/payment/payconiq@2x.png 2x,
          @/assets/images/icons/payment/payconiq@3x.png 3x
        "
        :alt="$t('paymentmethods.payconiq')"
        loading="lazy"
      />
      <img
        v-if="method === 'kaufAufRechung'"
        src="@/assets/images/icons/payment/kaufaufrechnung.png"
        srcset="
          @/assets/images/icons/payment/kaufaufrechnung.png,
          @/assets/images/icons/payment/kaufaufrechnung@2x.png 2x,
          @/assets/images/icons/payment/kaufaufrechnung@3x.png 3x
        "
        :alt="$t('paymentmethods.invoice-payment')"
        loading="lazy"
      />
      <img
        v-if="method === 'ingHomePay'"
        src="@/assets/images/icons/payment/inghomepay.png"
        srcset="
          @/assets/images/icons/payment/inghomepay.png,
          @/assets/images/icons/payment/inghomepay@2x.png 2x,
          @/assets/images/icons/payment/inghomepay@3x.png 3x
        "
        :alt="$t('paymentmethods.ing-homepay')"
        loading="lazy"
      />
      <img
        v-if="method === 'sofortBanking'"
        src="@/assets/images/icons/payment/sofortuberweisung.png"
        srcset="
          @/assets/images/icons/payment/sofortuberweisung.png,
          @/assets/images/icons/payment/sofortuberweisung@2x.png 2x,
          @/assets/images/icons/payment/sofortuberweisung@3x.png 3x
        "
        :alt="$t('paymentmethods.sofortueberweisung')"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
import PayPalIcon from '@/components/icons/PayPalIcon.vue';
import VisaIcon from '@/components/icons/VisaIcon.vue';
import KlarnaIcon from '@/components/icons/KlarnaIcon.vue';
import MastercardIcon from '@/components/icons/MastercardIcon.vue';
import AmericanExpressIcon from '@/components/icons/AmericanExpressIcon.vue';

export default defineNuxtComponent({
  components: {
    PayPalIcon,
    VisaIcon,
    KlarnaIcon,
    MastercardIcon,
    AmericanExpressIcon,
  },
  props: {
    methods: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
